export const productivity = {
  // Dashboard
  productivityCenter: 'Centro de Productividad',
  productivityCenterDescription: 'Tu centro de comando para metas, hábitos, tareas y recordatorios',
  loadingProductivityData: 'Cargando datos de productividad...',
  
  // Tabs
  overview: 'Resumen',
  management: 'Gestión',
  ai: 'IA',
  projects: 'Proyectos',
  advanced: 'Avanzado',
  calendar: 'Calendario',
  analytics: 'Analytics',
  activity: 'Actividad',
  
  // Overview
  todayMetrics: 'Métricas de Hoy',
  quickInsights: 'Insights Rápidos',
  metricsUnavailable: 'Métricas no disponibles',
  noMetricsData: 'No hay datos de métricas disponibles',
  recentActivity: 'Actividad Reciente', 
  viewAllActivity: 'Ver toda la actividad',
  noRecentActivity: 'Sin actividad reciente',
  noActivitiesFound: 'No se encontraron actividades',
  
  // Quick Actions
  quickActions: 'Acciones Rápidas',
  createGoal: 'Crear Meta',
  addTask: 'Agregar Tarea',
  trackHabit: 'Rastrear Hábito',
  setReminder: 'Configurar Recordatorio',
  
  // Quick Actions - Categories
  create: 'Crear',
  review: 'Revisar',
  analyze: 'Analizar',
  
  // Quick Actions - Items
  newGoal: 'Nueva Meta',
  setNewObjective: 'Establece un nuevo objetivo',
  newHabit: 'Nuevo Hábito',
  startHealthyHabit: 'Inicia un hábito saludable',
  newTask: 'Nueva Tarea',
  addDailyTask: 'Añade una tarea del día',
  reminder: 'Recordatorio',
  scheduleReminder: 'Programa un recordatorio',
  scheduleActivity: 'Programar Actividad',
  planNewActivity: 'Planifica una nueva actividad',
  newProject: 'Nuevo Proyecto',
  organizeTasksInProjects: 'Organiza tareas en proyectos',
  templates: 'Plantillas',
  useGoalTemplates: 'Usar plantillas de metas',
  viewProjects: 'Ver Proyectos',
  manageActiveProjects: 'Gestionar proyectos activos',
  calendarView: 'Calendario',
  viewFullAgenda: 'Ve tu agenda completa',
  analyticsView: 'Analytics',
  reviewProgress: 'Revisa tu progreso',
  
  // Navigation
  back: 'Volver',
  
  // Analytics
  productivityAnalytics: 'Analytics de Productividad',
  detailedAnalysis: 'Análisis detallado de tu rendimiento',
  selectPeriod: 'Seleccionar período',
  thisWeek: 'Esta semana',
  thisMonth: 'Este mes',
  thisQuarter: 'Este trimestre',
  globalScore: 'Puntuación Global',
  excellent: 'Excelente',
  good: 'Bueno',
  needsImprovement: 'Mejorable',
  goals: 'Metas',
  habits: 'Hábitos',
  tasks: 'Tareas',
  reminders: 'Recordatorios',
  completed: 'completadas',
  completionRate: 'tasa de completación',
  completedToday: 'completadas hoy',
  completionRates: 'Tasas de Completación',
  statusDistribution: 'Distribución de Estado',
  weeklyTrend: 'Tendencia Semanal',
  detailedBreakdown: 'Desglose Detallado',
  pending: 'Pendientes',
  
  // Calendar
  noActivitiesForDate: 'No hay actividades para esta fecha',
  weeklyView: 'Vista Semanal',
  noActivities: 'Sin actividades',
  activities: 'actividades',
  more: 'más',
  
  // Activity Feed
  activityFeed: 'Feed de Actividad',
  allActivities: 'Todas tus actividades en un lugar',
  filterByType: 'Filtrar por tipo',
  all: 'Todo',
  goal: 'Meta',
  habit: 'Hábito',
  task: 'Tarea',
  reminderType: 'Recordatorio',
  sortBy: 'Ordenar por',
  mostRecent: 'Más reciente',
  oldest: 'Más antiguo',
  dueDate: 'Fecha de vencimiento',
  priority: 'Prioridad',
  
  // Days of week
  monday: 'Lunes',
  tuesday: 'Martes',
  wednesday: 'Miércoles',
  thursday: 'Jueves',
  friday: 'Viernes',
  saturday: 'Sábado',
  sunday: 'Domingo',
  
  // Months short
  jan: 'Ene',
  feb: 'Feb',
  mar: 'Mar',
  apr: 'Abr',
  may: 'May',
  jun: 'Jun',
  jul: 'Jul',
  aug: 'Ago',
  sep: 'Sep',
  oct: 'Oct',
  nov: 'Nov',
  dec: 'Dic',
  
  // Overview metrics
  inProgress: 'progreso',
  overdue: 'atrasadas',
  streak: 'Racha',
  today: 'Hoy',
  next24h: 'próximos 24h',
  ok: 'ok',
  globalProgress: 'Progreso General',
  interestingData: 'Datos Interesantes',
  allGood: '¡Todo en orden!',
  
  // Projects
  activeProjects: 'Proyectos Activos',
  new: 'Nuevo',
  noActiveProjects: 'No tienes proyectos activos',
  createFirstProject: 'Crear Primer Proyecto',
  progress: 'Progreso',
  viewAllProjects: 'Ver todos los proyectos',
  
  // Templates
  goalTemplates: 'Plantillas de Metas',
  taskTemplates: 'Plantillas de Tareas',
  viewAll: 'Ver Todas',
  milestones: 'hitos',
  use: 'Usar',
  daysShort: 'd',
  minutesShort: 'm',
};